import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { ErrorButtonModel, ErrorAction } from '@core/models';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
  standalone: false
})
export class ModalErrorComponent implements OnInit {
  /**
   * icona
   */
  @Input() icon: string;

  /**
   * titolo
   */
  @Input() title: string;

  /**
   * messaggio
   */
  @Input() message: string;

  /**
   * istruzioni
   */
  @Input() instructions: string;

  /**
   * codice tech
   */
  @Input() techCode: string;

  /**
   * bottoni
   */
  @Input() buttons: ErrorButtonModel[];

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.initButtons();
  }

  /**
   * gestisce il click
   */
  onButtonClick(index: number): void {
    const btn = this.buttons[index];

    if (!btn) {
      return;
    }

    if (typeof btn.handler === 'function') {
      btn.handler();
    }

    if (btn.preventClosing !== true) {
      this.close(btn.action, btn.id);
    }
  }

  /**
   * inizializza i bottoni
   */
  private initButtons(): void {
    if (this.buttons instanceof Array) {
      return;
    }

    this.buttons = [
      {
        text: 'btn.error_retry',
        action: 'retry'
      }
    ];
  }

  /**
   * chiude la modale segnalando l'azione scelta
   */
  private close(action: ErrorAction, id?: string): void {
    this.modalController.dismiss({ action, id });
  }
}
